import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import ButtonComponent from '#app/Component/ButtonComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import ApiHandler, { ApiResponse } from '#app/Handler/ApiHandler';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import LoginFormLayout from '#app/View/Authentication/Login/components/LoginFormLayout';

const ResetPassword: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  const [form, setForm] = useState<Form>({
    password: {
      name: 'password',
      label: 'Mot de passe',
      textHelper: 'Nouveau mot de passe',
      type: 'password',
      options: {
        validation: ['required'],
        min: 6,
      },
    },
    confirmPassword: {
      name: 'confirmPassword',
      label: 'Confirmez le mot de passe',
      textHelper: 'Confirmez le mot de passe',
      type: 'password',
      options: { validation: ['required'] },
    },
  });

  const validatePasswords = () => {
    const formData = handleForm.getData();

    if (formData.password !== formData.confirmPassword) {
      handleForm.setError('confirmPassword', 'Les mots de passe ne correspondent pas');
      return true;
    }

    return false;
  };

  const handleForm = initFormHandler(form, setForm);
  useEffect(handleForm.start, []);

  const resetPassword = () => {
    if (!validatePasswords() && handleForm.checkError() < 1) {
      ApiHandler.post<string>(
        {
          route: 'api_reset_password',
          data: handleForm.getData(),
          params: { token: token! },
        },
        (response: ApiResponse<string>) => {
          const messageVariant = response.data ? 'success' : 'error';

          dispatch(
            SnackbarOpen({
              text: response.data ? response.data : response.error?.message || "Une erreur inattendue s'est produite.",
              variant: messageVariant,
            }),
          );

          if (messageVariant === 'success') {
            navigate(getRoutePathname('authentication_login'));
          }
        },
      );
    }
  };

  return (
    <LoginFormLayout>
      <strong>Réinitialisez votre mot de passe</strong>
      <TextFieldComponent id={'password'} handler={handleForm} />
      <TextFieldComponent id={'confirmPassword'} handler={handleForm} />
      <ButtonComponent type="submit" label="Réinitialiser" onClick={resetPassword} />
    </LoginFormLayout>
  );
};

export default ResetPassword;
